import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "../components/establishments-select-field.component";
import { TimePicker } from "antd";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";

const validationSchema = object().shape({});

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 210,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

// OPÇOES JEWELRY_TYPE //
const jewelry_typeToSelect = (options) => {
  return options.map((option) => ({
    value: option.jewelry_type,
    label: option.label,
  }));
};
const jewelry_typeOptionsPromise = () => {
  const api = new Api();
  const input = "jewelry_type";
  return api
    .get("/establishment_valences", { input })
    .then((res) => res.data)
    .then(jewelry_typeToSelect);
};

// OPÇOES CERTIFICAÇÃO //
const isCertifiedToSelect = (options) => {
  //console.log(options);
  return options.map((option) => ({
    value: option.is_certified,
    label: option.label,
  }));
};
const isCertifiedOptionsPromise = () => {
  const api = new Api();
  const input = "is_certified";
  return api
    .get("/establishment_valences", { input })
    .then((res) => res.data)
    .then(isCertifiedToSelect);
};

// OPÇOES RESTRIÇOES NAS VISITAS //
const hasScheduleRestrictionToSelect = (options) => {
  //console.log(options);
  return options.map((option) => ({
    value: option.has_schedule_restriction,
    label: option.label,
  }));
};
const hasScheduleRestrictionOptionsPromise = () => {
  const api = new Api();
  const input = "has_schedule_restriction";
  return api
    .get("/establishment_valences", { input })
    .then((res) => res.data)
    .then(hasScheduleRestrictionToSelect);
};

// EQUIPAMENTO COM CAMAS COMPARTICIPADAS //
const socialAidByIncomeToSelect = (options) => {
  //console.log(options);
  return options.map((option) => ({
    value: option.social_aid_by_income,
    label: option.label,
  }));
};
const socialAidByIncomeOptionsPromise = () => {
  const api = new Api();
  const input = "social_aid_by_income";
  return api
    .get("/establishment_valences", { input })
    .then((res) => res.data)
    .then(socialAidByIncomeToSelect);
};

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

export const EstablishmentFeaturesForm = ({
  classes = useStyles(),
  onSubmit,
  establishment,
}) => (
  <Formik
    initialValues={{
      short_description_pt: establishment.short_description_pt,
      short_description_en: establishment.short_description_en,
      short_description_fr: establishment.short_description_fr,
      full_description_pt: establishment.full_description_pt,
      full_description_en: establishment.full_description_en,
      full_description_fr: establishment.full_description_fr,
      search_keywords: establishment.search_keywords,
      max_users: establishment.max_users,
      max_users_reimbursed: establishment.max_users_reimbursed,
      founded_in: establishment.founded_in,
      is_certified: establishment.is_certified,
      has_schedule_restriction: establishment.has_schedule_restriction,
      schedule_hour_start: moment(establishment.schedule_hour_start).format(
        "HH:mm:ss"
      ),
      schedule_hour_end: moment(establishment.schedule_hour_end).format(
        "HH:mm:ss"
      ),
      jewelry_type: establishment.jewelry_type,
      jewelry_value: establishment.jewelry_value,
      max_price: establishment.max_price,
      min_price: establishment.min_price,
      max_price_social_aid: establishment.max_price_social_aid,
      min_price_social_aid: establishment.min_price_social_aid,
      social_aid_by_income: establishment.social_aid_by_income,
      license_path: establishment.license_path,
      license_filename: establishment.license_filename,
    }}
    onSubmit={handleSubmitting(onSubmit)}
    /*onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                console.log(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);}}*/
    validationSchema={validationSchema}
    validateOnChange={false}
    validateOnBlur={false}
    render={({
      values,
      handleSubmit,
      setFieldValue,
      setFieldTouched,
      handleChange,
    }) => {
      return (
        <form onSubmit={handleSubmit}>
          <div className="form_establishmentFeaturesAlign">
            <Grid item md={4} className="new-card-inner">
              <Field
                name="short_description_pt"
                label="Resumo (PT)"
                type="text"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.short_description_pt}
                multiline={true}
                fullWidth
                rows="4"
              />
            </Grid>
            <Grid item md={4} className="new-card-inner">
              <Field
                name="short_description_en"
                label="Resumo (EN)"
                type="text"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.short_description_en}
                multiline={true}
                fullWidth
                rows="4"
              />
            </Grid>
            <Grid item md={4} className="new-card-inner">
              <Field
                name="short_description_fr"
                label="Resumo (FR)"
                type="text"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.short_description_fr}
                multiline={true}
                fullWidth
                rows="4"
              />
            </Grid>
          </div>

          <Grid item md={12} className="new-card-inner">
            <Field
              name="full_description_pt"
              label="Descrição (PT)"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.short_description_pt}
              multiline={true}
              fullWidth
              rows="6"
            />
          </Grid>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="full_description_en"
              label="Descrição (EN)"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.short_description_en}
              multiline={true}
              fullWidth
              rows="6"
            />
          </Grid>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="full_description_fr"
              label="Descrição (FR)"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.short_description_fr}
              multiline={true}
              fullWidth
              rows="6"
            />
          </Grid>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="search_keywords"
              label="Termos de Pesquisa - separados por vírgula (,)"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.search_keywords}
              multiline={true}
              fullWidth
            />
          </Grid>

          <div className="d-flex">
            <Grid item md={12} className="new-card-inner align4">
              <Field
                name="max_users"
                label="Lotação"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.max_users}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4">
              <Field
                name="max_users_reimbursed"
                label="Lotação com Comparticipação"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.max_users_reimbursed}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4">
              <Field
                name="founded_in"
                label="Fundado (ano)"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.founded_in}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4">
              <Field
                name="is_certified"
                label="Certificação"
                type="text"
                variant="outlined"
                margin="normal"
                optionsFetcher={isCertifiedOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={"" + values.is_certified}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4">
              <Field
                name="has_schedule_restriction"
                label="Restrição nas visitas"
                type="text"
                variant="outlined"
                margin="normal"
                optionsFetcher={hasScheduleRestrictionOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={"" + values.has_schedule_restriction}
              />
            </Grid>
          </div>
          <div className="form_establishmentFeaturesAlign">
            <Grid item md={12} className="new-card-inner align4">
              <div class="mb-4 mt-2">
                {" "}
                <InputLabel class="small text-secondary">
                  Hora de Início *
                </InputLabel>
                <input
                  class="form-control mb-1"
                  name="schedule_hour_start"
                  type="time"
                  margin="normal"
                  onChange={handleChange}
                  component={TimePicker}
                  value={values.schedule_hour_start}
                />
              </div>
            </Grid>

            <Grid item md={12} className="new-card-inner align4">
              <div class="mb-4 mt-2">
                {" "}
                <InputLabel class="small text-secondary">
                  Hora de Fim *
                </InputLabel>
                <input
                  class="form-control mb-1"
                  name="schedule_hour_end"
                  type="time"
                  margin="normal"
                  onChange={handleChange}
                  component={TimePicker}
                  value={values.schedule_hour_end}
                />
              </div>
            </Grid>

            <Grid item md={12} className="new-card-inner align4 mt-2">
              <Field
                name="min_price"
                label="Mensalidade mínima"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.min_price}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4 mt-2">
              <Field
                name="max_price"
                icon="users"
                label="Mensalidade máxima"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.max_price}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4 mt-2">
              <Field
                name="jewelry_type"
                label="Jóia / Caução"
                type="text"
                variant="outlined"
                margin="normal"
                optionsFetcher={jewelry_typeOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={"" + values.jewelry_type}
              />
            </Grid>

            <Grid item md={12} className="new-card-inner align4 mt-2">
              <Field
                name="jewelry_value"
                label="Valor da Jóia / Caução"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.jewelry_value}
              />
            </Grid>
          </div>

          <div className="form_establishmentFeaturesAlign">
            <Grid item md={4} className="new-card-inner align4">
              <Field
                name="min_price_social_aid"
                label="Mensalidade mínima camas comparticipadas"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.min_price_social_aid}
              />
            </Grid>

            <Grid item md={4} className="new-card-inner align4">
              <Field
                name="max_price_social_aid"
                icon="users"
                label="Mensalidade máxima camas comparticipadas"
                type="number"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.max_price_social_aid}
              />
            </Grid>

            <Grid item md={4} className="new-card-inner align4">
              <Field
                name="social_aid_by_income"
                label="Equipamento com camas comparticipadas"
                type="number"
                variant="outlined"
                margin="normal"
                optionsFetcher={socialAidByIncomeOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={"" + values.social_aid_by_income}
              />
            </Grid>
          </div>

          <Grid item md={12} className="new-card-inner align4">
            <Field
              name="license_filename"
              label="N.º de licença"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.license_filename}
              multiline={true}
            />
          </Grid>

          {/* <div className="form_establishmentFeaturesAlign">
                <Grid item md={10} className="new-card-inner align4">
                  <Field
                    label="Licença (PDF)"
                    name="license_path"
                    type="search"
                    variant="outlined"
                    margin="normal"
                    component={TextField}
                    value={values.license_path}
                    width={450}
                  />
                </Grid>
                <Grid item md={1} className="new-card-inner align4">
                  {establishment.license_path != "" && (
                  <Button
                    id="button-see-pdf"
                    className="mr-2 mt-4"
                    variant="contained"
                    type="button"
                    size="small"
                    ><a href={"https:www.laresonline.pt/"+establishment.license_path}>Ver PDF</a>
                  </Button>
                  )}
                </Grid>
              </div> */}

          {/* Ver com o Joao para onde é para fazer upload. Falta validaçao BE do ficheiro */}
          {/* <Grid item md={1} className="new-card-inner align4">
                <div class="upload-wrap">
                  <input id="upload_license_id" type="file" accept="aplication/pdf" />
                </div>
              </Grid> */}

          <br />
          <Button
            variant="contained"
            type="submit"
            size="small"
            style={{ marginTop: "20px" }}
          >
            Atualizar
          </Button>
        </form>
      );
    }}
  />
);
